import { FC } from 'react';

import { Divider, StyleProps } from '@bonusly/design-system';

export const NavDivider: FC<StyleProps> = (props) => <Divider borderColor="gray.50" my={1} {...props} />;
